import { render, staticRenderFns } from "./aRmsRevenueServicetypeChart.vue?vue&type=template&id=c8370016"
import script from "./aRmsRevenueServicetypeChart.vue?vue&type=script&lang=js"
export * from "./aRmsRevenueServicetypeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports